export default {
  mobile: false
}


// WEBPACK FOOTER //
// ./src/reducers/initial-states/config.js